import React, { useState, useEffect } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { FiChevronDown } from "react-icons/fi";

// Generic single-select styled to match PaymentDropdown / VendorDropDown, so
// new PO fields (e.g. Ship Via) look identical to the pickers already on the
// form. Selection is by value, not index.
const OptionDropdown = ({ options = [], value, onSelect, placeholder = "Select" }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selected, setSelected] = useState(value ?? "");

  useEffect(() => {
    setSelected(value ?? "");
  }, [value]);

  const itemSelected = (option) => {
    setSelected(option);
    onSelect(option);
    setDropdownOpen(false);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setDropdownOpen(false)}>
      <div className="w-full h-[30px] border-solid border-[1px] rounded-[6px] border-borderColor relative pr-4">
        <div
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="w-full h-full flex items-center justify-between cursor-pointer"
        >
          <p className={`text-[12px] font-OpenSansRegular px-3 ${selected ? "text-titleColor" : "text-subTitleColor"}`}>
            {selected || placeholder}
          </p>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {dropdownOpen && (
          <div className="w-full absolute top-[30px] left-0 border-solid border-[1px] rounded-[6px] border-borderColor bg-white z-30 max-h-[160px] overflow-y-auto">
            {options.map((option) => (
              <div
                key={option}
                className={`h-[30px] px-[6px] cursor-pointer flex items-center transition-colors ${
                  selected === option ? "bg-gray-200" : ""
                } hover:bg-gray-200`}
                onClick={() => itemSelected(option)}
              >
                <span className="text-[12px] text-titleColor">{option}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default OptionDropdown;
